// Gemerkte Ansicht der Opportunity-Listen (Spalten, Sortierung, Anzeige-Optionen), je Nutzer in `listen_ansichten`
// (`listenAnsichtenApi`, Runde 5B). Solange der Server das nicht kann oder nicht antwortet, hält der Browser die Wahl
// (localStorage, jeder Zugriff abgesichert). Der Server gewinnt, wenn er eine Ansicht kennt.
import { listenAnsichtenApi, type AnsichtEingabe } from "../api/listenAnsichten";

export interface Ansicht {
  spalten: string[] | null;
  sortierung: { key: string; ab: boolean }[] | null;
  einstellungen: Record<string, unknown>;
}

const LEER: Ansicht = { spalten: null, sortierung: null, einstellungen: {} };
const PRAEFIX = "crm-opportunities-ansicht:";

function lokalLesen(liste: string): Ansicht | null {
  try {
    const roh = localStorage.getItem(PRAEFIX + liste);
    if (!roh) return null;
    const a = JSON.parse(roh) as Partial<Ansicht>;
    return { spalten: a.spalten ?? null, sortierung: a.sortierung ?? null, einstellungen: a.einstellungen ?? {} };
  } catch {
    return null;
  }
}

function lokalSchreiben(liste: string, a: Ansicht): void {
  try {
    localStorage.setItem(PRAEFIX + liste, JSON.stringify(a));
  } catch {
    /* Speicher gesperrt oder voll: dann gilt die Wahl nur bis zum Neuladen */
  }
}

export async function ansichtLesen(liste: string): Promise<Ansicht> {
  try {
    const r = await listenAnsichtenApi.eine(liste);
    if (r.ansicht) {
      const a: Ansicht = { spalten: r.ansicht.spalten, sortierung: r.ansicht.sortierung, einstellungen: r.ansicht.einstellungen ?? {} };
      lokalSchreiben(liste, a);
      return a;
    }
  } catch {
    /* Server kennt die Ansicht nicht oder antwortet nicht: lokal weiter */
  }
  return lokalLesen(liste) ?? { ...LEER };
}

/** Teile der Ansicht merken (nur die gesendeten ändern sich; `null` = Standard). Ein Fehler beim Server stört nicht. */
export async function ansichtMerken(liste: string, teil: AnsichtEingabe): Promise<void> {
  const bisher = lokalLesen(liste) ?? { ...LEER };
  lokalSchreiben(liste, {
    spalten: teil.spalten !== undefined ? teil.spalten : bisher.spalten,
    sortierung: teil.sortierung !== undefined ? teil.sortierung : bisher.sortierung,
    einstellungen: teil.einstellungen !== undefined ? { ...bisher.einstellungen, ...(teil.einstellungen ?? {}) } : bisher.einstellungen,
  });
  try {
    await listenAnsichtenApi.merken(liste, teil.einstellungen ? { ...teil, einstellungen: { ...bisher.einstellungen, ...teil.einstellungen } } : teil);
  } catch {
    /* bleibt lokal */
  }
}
